<template>
  <div>
    <div class="toggle-line" :style="drawerStyle"
      @click="onMouserEnter" v-show="showIcon">
    </div>
    <div id="account-tree-toggle-btn"
      class="toggle-btn account-tree-toggle-btn"
      @click="onMouserEnter" v-show="showIcon">
      <byted-icon name="double-angle-left"></byted-icon>
    </div>
    <byted-drawer
      v-if="showDom"
      class="account-tree-drawer"
      :width="13"
      placement="left"
      :closable="false"
      :mask-closable="false"
      :maskable="false"
      :drawer-style="drawerStyle"
      v-model="showLine">
      <div class="account-tree-line"
          @click="clickToggle"
          @mouseenter="onMouseEnterLine"
          @mouseleave="onMouseLeaveLine">
        <div class="toggle-btn" :style="drawerBtnStyle">
          <byted-icon name="double-angle-left"></byted-icon>
        </div>
      </div>
    </byted-drawer>
    <byted-drawer
      v-if="showDom"
      class="account-tree-drawer"
      :width="300"
      placement="left"
      :closable="false"
      :mask-closable="false"
      :maskable="false"
      :drawer-style="drawerStyle"
      v-model="showTree">
      <div class="account-tree-container"
        :class="{show: showTree}"
        @mouseenter="onMouseEnterTree"
        @mouseleave="onMouseLeaveTree">
        <div class="toggle-btn" @click="clickToggle" :style="drawerBtnStyle">
          <byted-icon name="double-angle-right"></byted-icon>
        </div>
        <div class="filter-header-wrapper">
          <div class="filter-item">
            <byted-dropdown @on-click="onClickFilter">
              <div class="filter-btn">
                <byted-icon name="filter"></byted-icon>
                <div class="txt-cut">{{filterTexts[filter]}}</div>
              </div>
              <byted-dropdown-menu slot="list">
                <byted-dropdown-item v-for="(text, index) in filterTexts"
                  :class="{selected: parseInt(filter) === index}"
                  :name="index.toString()">{{text}}</byted-dropdown-item>
              </byted-dropdown-menu>
            </byted-dropdown>
          </div>
          <div class="filter-item">
            <byted-dropdown @on-click="onClickSort">
              <div class="filter-btn">
                <byted-icon name="_promotion_sort"></byted-icon>
                <div class="txt-cut">{{sortMap[sortType]}}</div>
              </div>
              <byted-dropdown-menu slot="list">
                <byted-dropdown-item v-for="(text, key) in sortMap"
                  :class="{selected: sortType === key}"
                  :name="key">{{text}}</byted-dropdown-item>
              </byted-dropdown-menu>
            </byted-dropdown>
          </div>
        </div>
        <div class="filter-query ad-p-t ad-p-l ad-p-r ad-p-b">
          <byted-input v-model="searchText" placeholder="搜索组/计划名称"
            prefix="search" clearable @input="searchAccountTree"
          ></byted-input>
        </div>
        <div class="body-wrapper"
          v-byted-loading="isLoading">
          <div v-if="Object.keys(currentAccountTree).length === 0" class="tree-none">
            <img src="../../static/images/icon/audience-none-words.svg" alt>
            <div>{{ $bp_t('暂无相关数据', 'common.no_data_available') }}</div>
          </div>
          <div class="tree-group-wrapper">
            <!--推广目的组-->
            <div class="tree-group"
              :class="{opened: typeIsOpened(landingType)}"
              v-if="campaigns.length >= 1"
              v-for="(campaigns, landingType) in currentAccountTree">
              <h3 class="landing-type-title ad-d-flex"
                  @click="onClickLandingType(landingType)">
                <byted-icon :name="getIconName(landingType)"
                            class="landing-type-icon ad-m-r-xxs"></byted-icon>
                <div class="txt-cut"
                     :title="landingTypeName[landingType]">
                  {{landingTypeName[landingType]}}
                </div>
                <byted-icon name="angle-down"></byted-icon>
              </h3>
              <!--广告组-->
              <div class="campaign-group-wrapper"
                v-if='openedLandingType === landingType'
                :class="{opened: IDIsOpened(campaign.campaign_id)}"
                v-for="(campaign, campaignIndex) in campaigns">
                <h4 class="campaign-name-title ad-d-flex"
                  :title="campaign.campaign_name">
                  <byted-icon name="sort-asc"
                    class="ad-m-r-xxs"
                    @click="onClickToggleCampaign(campaign.campaign_id, landingType, campaignIndex)"></byted-icon>
                  <div class="campaign-name"
                    @click="onClickCampaign(campaign.campaign_id, landingType)">
                    <span class="txt-cut" v-html="filterHtml(campaign.campaign_name)" :title="campaign.names || campaign.campaign_name" data-no-translate></span>
                    <!-- yangbo 后缀的数量显示只在手动创建的计划下显示 delivery_mode 值为2的情况下是自动创建-->
                    <span v-if="campaign.delivery_mode !== 2">({{campaign.ads.length}})</span>
                  </div>
                </h4>
                <!--计划组-->
                <ul class="ad-lists">
                  <li class="ad-item"
                    :title="ad.ad_name"
                    v-for="ad in campaign.ads"
                    @click="onClickAd(ad.ad_id, campaign.delivery_mode === 2)">
                    <span v-if="campaign.delivery_mode === 2" class='account-tree-ad-prefix'>自动</span>
                    <span class="txt-cut" v-html="filterHtml(ad.ad_name)" :title="ad.names || ad.ad_name" data-no-translate></span>
                    <span v-if="campaign.delivery_mode !== 2">({{ad.creative_count}})</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </byted-drawer>
  </div>
</template>

<script>
  import Apis from 'Src/const/apis'
  import ApiUrl from 'Src/const/apis/promotion/index'
  import { landingType } from 'Src/const/state/campaign.js'
  import { safetyGet, secHtml } from 'Src/util/tool'
  import { getCurQuery } from 'Src/pagelets/promotion/common.js'

  const Order = {
    asc: 0,
    desc: 1,
  }

  const ShowType = {
    icon: 0,
    line: 1,
    tree: 2
  }

  const LandingTypeMap = {
    app: landingType.DOWNLOAD.value,
    external: landingType.EXTERNAL.value,
    aweme_popularize: landingType.AWEME_POPULARIZE.value,
    goods: landingType.GOODS.value,
    advertiser_store: landingType.ADVERTISER_STORE.value,
    shop: landingType.SHOP.value,
    dynamic_product_library: landingType.PRODUCT_LIBRARY.value,
    article: landingType.ARTICLE.value
  }

  export default {
    name: 'account-tree',
    props: {
      drawerStyle: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        isLoading: false,
        filter: 0,
        filterTexts: [
          $bp_t('所有广告', 'bp.promotion_all_advertisements'),
          $bp_t('近一周有消耗计划', 'bp.promotion_consumption_plan_in_the_past_week'),
          $bp_t('近一周新建计划', 'bp.promotion_new_plan_in_the_past_week')
        ],
        sortKey: 'create_time',
        sortOrder: Order.desc,
        sortType: 'create_time-desc',
        sortMap: {
          'create_time-desc': $bp_t('创建时间新到旧', 'bp.promotion_new_to_old_creation_time'),
          'create_time-asc': $bp_t('创建时间旧到新', 'bp.promotion_old_to_new_creation_time'),
          'stat_cost-desc': $bp_t('消耗由高到低', 'bp.promotion_consumption_from_high_to_low'),
          'stat_cost-asc': $bp_t('消耗由低到高', 'bp.promotion_consumption_from_low_to_high')
        },
        landingTypeName: {
          app: $bp_t('应用推广', 'common.application_and_popularization'),
          external: $bp_t('销售线索收集', 'common.lead_collection'),
          aweme_popularize: $bp_t('抖音号推广', 'common.promotion_of_buffeting_signal'),
          goods: $bp_t('商品推广', 'common.commodity_promotion'),
          advertiser_store: $bp_t('门店推广', 'common.store_promotion'),
          shop: $bp_t('电商店铺推广', 'common.e_commerce_shop_promotion'),
          dynamic_product_library: $bp_t('商品目录推广', 'bp.promotion_product_catalog_promotion'),
          article: $bp_t('头条文章推广', 'common.headline_promotion')
        },
        accountTree: {},
        openedLandingType: '',
        openedCampaignsID: [],
        hideTimeoutPointer: undefined,
        searchText: '',
        currentAccountTree: {},
        showType: ShowType.icon,
        showTreeTimeout: undefined,
        showDom: false
      }
    },
    computed: {
      curQuery() {
        if (Object.keys(this.$route.query) > 0) {
          return this.$route.query
        }
        return getCurQuery()
      },
      queryParams () {
        return {
          status: this.filter,
          sort_stat: this.sortKey,
          sort_order: this.sortOrder
        }
      },
      showIcon () {
        return this.showType === ShowType.icon
      },
      showLine () {
        return this.showType === ShowType.line
      },
      showTree () {
        return this.showType === ShowType.tree
      },
      // 悬浮按钮的位置始终为屏幕50%
      drawerBtnStyle () {
        const num = parseInt(this.drawerStyle.top)/2
        return {
          top: `calc(50% - ${num}px)`
        }
      }
    },
    mounted() {
      // this.getTreeData()
    },
    watch: {
      searchText (newVal) {
        if (newVal.trim().length === 0) {
          this.currentAccountTree = this.accountTree
        }
      }
    },
    methods: {
      filterHtml(str){
        return secHtml(str)
      },
      getTreeData () {
        this.isLoading = true

        this.openedLandingType = ''
        this.openedCampaignsID = []

        // API Doc: https://bytedance.feishu.cn/space/doc/doccn5RVlYJY245h8bcUZeuGavb#
        BUI.update({
          url: ApiUrl.tree.catalog,
          // url: 'https://mock.bytedance.net/mock/5d08e32467d0ef01ffdefce9/promotion/accountTree',
          data: JSON.stringify(this.queryParams),
          contentType: 'application/json',
          success: (resp) => {
            if (resp && resp.code === 0) {
              this.accountTree = resp.data
              // init数据，标记每条数据没有获取创意数量
              Object.keys(this.accountTree).forEach(adType => {
                if (this.openedLandingType === '' && this.accountTree[adType] && this.accountTree[adType].length) {
                  this.openedLandingType = adType
                }
                this.accountTree[adType].forEach(campaign => {
                  campaign.loadCreativeCount = false
                })
              })
              this.currentAccountTree = this.accountTree
              this.isLoading = false
            } else {
              this.$message($bp_t('获取账户树数据失败，网络错误，请重试或联系管理员', 'bp.promotion_failed_to_get_the_account_tree_data_network_error') || resp.msg, 'error')
            }
          },
          error: (err) => {
            this.$message($bp_t('获取账户树数据失败，网络错误，请重试或联系管理员', 'bp.promotion_failed_to_get_the_account_tree_data_network_error') + err.status, 'error')
          }
        })
      },
      onMouserEnter () {
        this.showDom = true
        if (Object.keys(this.currentAccountTree).length === 0 && !this.isLoading) {
          this.getTreeData()
        }
        // 不做延时快速在line和常驻icon间来回切换会全都消失
        setTimeout(() => this.showType = ShowType.tree, 50)
          window.teaEvent('promotion_account_tree_open', {
            advertiser_id: GLOBAL_VAR.advertiser.id,
            advertiser_name: GLOBAL_VAR.advertiser.name
          })
      },
      onMouseLeaveTree () {
        this.hideTimeoutPointer = setTimeout(() => {
          this.showType = ShowType.icon
        }, 300)
      },
      onMouseEnterTree () {
        if (this.hideTimeoutPointer) {
          clearTimeout(this.hideTimeoutPointer)
        }
      },
      onMouseLeaveLine () {
        if (this.showTreeTimeout) {
          clearTimeout(this.showTreeTimeout)
        }
        if (this.showTree) return
        this.showType = ShowType.icon
      },
      onMouseEnterLine () {
        this.showTreeTimeout = setTimeout(() => {
          this.showType = ShowType.tree
          window.teaEvent('promotion_account_tree_open', {
            advertiser_id: GLOBAL_VAR.advertiser.id,
            advertiser_name: GLOBAL_VAR.advertiser.name
          })
        }, 1000)
      },
      clickToggle () {
        this.showType = this.showType === ShowType.tree ? ShowType.icon : ShowType.tree
      },
      typeIsOpened (type) {
        return (this.openedLandingType === type)
      },
      onClickLandingType (type) {
        if (type === this.openedLandingType) {
          this.openedLandingType = ''
        } else {
          this.openedLandingType = type
          if(this.searchText.trim().length === 0) this.openedCampaignsID = []
        }
      },
      IDIsOpened (id) {
        return (this.openedCampaignsID.indexOf(id) !== -1)
      },
      onClickToggleCampaign(id, landingType, campaignIndex) {
        let adList = this.currentAccountTree[landingType][campaignIndex].ads || []
        if (adList.length > 0 && !this.currentAccountTree[landingType][campaignIndex].loadCreativeCount) {
          let adIds = adList.map(item => item.ad_id)
          BUI.update({
            url: ApiUrl.tree.creativeCount,
            data: JSON.stringify({ad_ids: adIds}),
            contentType: 'application/json',
            success: (resp) => {
              if (resp.code === 0) {
                const { data: { ad_id_to_count } } = resp
                this.currentAccountTree[landingType][campaignIndex].ads.forEach(item => {
                  item.creative_count = ad_id_to_count[item.ad_id] || 0
                })
                this.currentAccountTree[landingType][campaignIndex].loadCreativeCount = true
                this.currentAccountTree = JSON.parse(JSON.stringify(this.currentAccountTree))
              } else {
                this.$message(resp.msg, 'error')
              }
            },
            error: (err) => {
              this.$message('获取账户树数据失败，网络错误，请重试或联系管理员：' + err.status, 'error')
            }
          })
        }

        const curIDIndex = this.openedCampaignsID.indexOf(id)
        if (curIDIndex === -1) {
          this.openedCampaignsID.push(id)
        } else {
          this.openedCampaignsID.splice(curIDIndex, 1)
        }
      },
      onClickFilter (paramsVal) {
        this.filter = paramsVal

        this.getTreeData()

        window.teaEvent('promotion_act_tree_op', {
          advertiser_id: GLOBAL_VAR.advertiser.id,
          advertiser_name: GLOBAL_VAR.advertiser.name,
          type: 'filter',
          filter_key: 'status',
          value: this.filter
        })
      },
      onClickSort (sortType) {
        this.sortType = sortType
        const [key, order] = sortType.split('-')
        this.sortKey = key
        this.sortOrder = Order[order]

        this.getTreeData()

        window.teaEvent('promotion_act_tree_op', {
          advertiser_id: GLOBAL_VAR.advertiser.id,
          advertiser_name: GLOBAL_VAR.advertiser.name,
          type: 'sort',
          filter_key: key,
          value: order
        })
      },
      onClickCampaign (id, landingType) {
        let query = JSON.parse(JSON.stringify(this.curQuery))
        if (query.local_ad_id) delete query.local_ad_id
        query['local_campaign_id'] = id
        query['landing_type'] = safetyGet(LandingTypeMap, `${landingType}`)

        this.$router.push({
          name: 'ad',
          query
        })

        window.teaEvent('promotion_act_tree_drill', {
          advertiser_id: GLOBAL_VAR.advertiser.id,
          advertiser_name: GLOBAL_VAR.advertiser.name,
          type: 'campaign'
        })
      },
      onClickAd (id, type) {
        let query = JSON.parse(JSON.stringify(this.curQuery))
        if (query.local_campaign_id) delete query.local_campaign_id
        if (type) {
          query['local_ad_group_id'] = id
          query.local_ad_id && delete query.local_ad_id
        } else {
          query['local_ad_id'] = id
          query.local_ad_group_id && delete query.local_ad_group_id
        }

        this.$router.push({
          name: 'creative',
          query
        })

        window.teaEvent('promotion_act_tree_drill', {
          advertiser_id: GLOBAL_VAR.advertiser.id,
          advertiser_name: GLOBAL_VAR.advertiser.name,
          type: 'ad'
        })
      },
      getIconName(landingTypeKey) {
        return `__promotion_tree_${landingTypeKey}`
      },
      searchAccountTree: _.debounce(function () {
        if (this.searchText.trim().length > 0) {
          this.currentAccountTree = {}
          Object.keys(this.accountTree).forEach(key => {
            const data = this.accountTree[key]
            if (data && data.length) {
              const currentCamps = []
              data.forEach(camp => {
                const campRes = camp.campaign_name.indexOf(this.searchText)
                const currentAds = []
                camp.ads && camp.ads.length && camp.ads.forEach(ad => {
                  const adRes = ad.ad_name.indexOf(this.searchText)
                  adRes > -1 && currentAds.push({
                    ad_id: ad.ad_id,
                    ad_name: this.getLightText(adRes, ad.ad_name),
                    names: ad.ad_name,
                    creative_count: ad.creative_count
                  })
                })
                if (currentAds.length > 0 || campRes > -1) {
                  currentCamps.push({
                    campaign_id: camp.campaign_id,
                    campaign_name: this.getLightText(campRes, camp.campaign_name),
                    names: camp.campaign_name,
                    ads: currentAds
                  })
                  currentAds.length > 0 && this.openedCampaignsID.push(camp.campaign_id)
                }
              })
              if (currentCamps.length) {
                this.currentAccountTree[key] = currentCamps
              }
            }
          })
        }
      }, 500),
      getLightText (index, name) {
        return index > -1 ? name.slice(0, index)
          + '<span class="light">' + name.slice(index, index + this.searchText.length)
          +'</span>' + name.slice(index + this.searchText.length): name
      }
    }
  }
</script>

<style lang="scss">
  $active-color: #2f88ff;

  $font-size: 14px;
  $small-font-size: 12px;
  $icon-size: 16px;

  $max-name-width: 200px;

  @mixin before-pseudo-el() {
    content: '';
    display: block;
    background-color: #E4E9ED;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
  @mixin show-transition() {
    transition: transform linear .2s;
  }

  .account-tree-ad-prefix{
    display: inline-block;
    width:27px;
    height:16px;
    font-size:10px;
    color: white;
    background: #FAAD15;
    margin-right:2px;
    border-radius: 2px;
    padding:0 2px 0 1px;
    line-height:16px;
    transform: scale(0.9);
  }

  .toggle-line {
    width: 1px;
    position: fixed;
    top: 0;
  }

  $toggle-btn-width: 18px;
  .toggle-btn {
    cursor: pointer;
    position: absolute;
    right: -$toggle-btn-width;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    width: $toggle-btn-width;
    height: 50px;
    background: #556376;
    border-radius: 0px 4px 4px 0px;
    &.account-tree-toggle-btn {
      position: fixed;
      left: 0;
      right: auto;
      z-index: 996;
    }
    .byted-icon, img {
      transform: rotate(180deg);
      fill: #fff;
      width: $icon-size;
      height: $icon-size;
    }
  }

  .account-tree-drawer {
    .bui-drawer-body {
      // 避免 dropdown 被遮挡，利用内部body控制 overflow
      overflow: visible !important;
    }
  }

  .account-tree-container {
    width: 100%;
    height: 100%;
    font-size: $font-size;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
    line-height: 20px;
    background-color: #fff;
    box-shadow: 1px 0px 6px 0 rgba(0, 0, 0, 0.05);
    &.show {
      .toggle-btn {
        .byted-icon {
          transform: rotate(180deg);
        }
      }
    }
    .byted-icon {
      flex-shrink: 0;
      @include show-transition();
      width: $small-font-size;
      height: $small-font-size;
    }
    .toggle-btn {
      .byted-icon {
        width: $icon-size;
        height: $icon-size;
      }
    }
    $filter-height: 40px;
    .filter-header-wrapper {
      width: 100%;
      display: flex;
      height: $filter-height;
      background-color: #F8F9FA;
      border-bottom: 1px solid #E4E9ED;
      .filter-item {
        font-size: $small-font-size;
        box-sizing: border-box;
        width: 50%;
        background-color: #F8F9FA;
        position: relative;
        padding: 10px 16px;
        &:first-child:before {
          @include before-pseudo-el();
          width: 1px;
        }
        .byted-dropdown {
          width: 100%;
        }
        .byted-dropdown-item.selected {
          color: $active-color;
        }
      }
      $dropdown-height: 20px;
      .filter-btn {
        cursor: pointer;
        height: $dropdown-height;
        line-height: $dropdown-height;
        display: flex;
        align-items: center;
        &:hover {
          color: $active-color;
          .byted-icon {
            fill: $active-color;
          }
        }
        .byted-icon {
          width: $small-font-size;
          height: $small-font-size;
          margin-right: 4px;
        }
      }
    }
    .body-wrapper {
      height: 100%;
      overflow: auto;
      padding: 8px 16px 16px 16px;
    }
    .tree-group {
      margin-bottom: 24px;
      &.opened {
        .campaign-group-wrapper {
          display: block;
        }
        .landing-type-title .bui-icon-angle-down {
          transform: rotate(180deg);
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .tree-group-wrapper {
      h3, h4, ul, li {
        margin: 0;
      }
      .landing-type-title {
        font-family:PingFangSC-Semibold;
        font-weight:600;
        cursor: pointer;
        font-size: $font-size;
        line-height: 22px;
        margin-bottom: 8px;
        &:hover {
          color: $active-color;
          .byted-icon {
            fill: $active-color;
          }
        }
        .byted-icon {
          width: $font-size;
          height: $font-size;
        }
        .landing-type-icon {
          width: $icon-size;
          height: $icon-size;
        }
        .bui-icon-angle-down {
          margin-left: auto;
        }
      }
      .campaign-group-wrapper {
        display: none;
        cursor: pointer;
        margin-left: 20px;
        margin-bottom: 4px;
        &.opened {
          .ad-lists {
            display: block;
          }
          .campaign-name-title {
            .bui-icon-sort-asc {
              transform: rotate(180deg);
            }
          }
        }
        .campaign-name-title {
          font-size: $font-size;
          line-height: 22px;
          .bui-icon-sort-asc {
            transform: rotate(90deg);
          }
          .byted-icon:hover {
            fill: $active-color;
          }
          .campaign-name {
            font-weight: 400;
            max-width: 220px;
            white-space: nowrap;
            display: flex;
            align-items: center;
            padding: 4px;
            border-radius: 4px;
            &:hover {
              background-color: #EDF1F5;
            }
          }
        }
      }
      .ad-lists {
        display: none;
        padding-left: 16px;
        margin-top: 8px;
        margin-left: 20px;
        .ad-item {
          max-width: $max-name-width;
          white-space: nowrap;
          display: flex;
          align-items: center;
          cursor: pointer;
          position: relative;
          padding: 4px;
          border-radius: 4px;
          margin-bottom: 4px;
          .txt-cut  {
            display: inline-block;
            max-width: 100%;
          }
          &:hover {
            background-color: #EDF1F5;
            &:before {
              background-color: $active-color;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .light {
    color: $active-color
  }

  .tree-none {
    display: flex;
    align-items: center;
    flex-flow: column;
    margin-top: 230px;

    div {
      margin-top: 9px;
      font-size: 14px;
      line-height: 22px;
      color: #C1C1C1;
    }
  }

  .account-tree-line {
    width: 13px;
    height: 100%;
    min-height: 1px;
    background: #fff;
    position: fixed;
    left: 0;
    z-index: 997;
  }
</style>
<style lang="scss" scoped>
/deep/ .bui-drawer-body {
  padding: 0 !important;
}
</style>
